module.exports = __webpack_public_path__ + "img/img_service_03.9b08ab7e.jpg";